import { useQuery } from '@tanstack/react-query';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { getProfile, validatePhone } from './profile.api';

export const PROFILE_QUERY_KEY = 'profile';
export const PHONE_VALIDATION_QUERY_KEY = 'phone-validation';

type UserProfileFn = typeof getProfile;
type PhoneValidationFn = typeof validatePhone;

export const useUserProfile = (enable: boolean) => {
  return useQuery<ApiFnReturnType<UserProfileFn>>({
    queryKey: [PROFILE_QUERY_KEY],
    queryFn: getProfile,
    enabled: enable,
  });
};

export const usePhoneValidation = (phoneNumber: string, regionCode: string) => {
  return useQuery<ApiFnReturnType<PhoneValidationFn>>({
    queryKey: [PHONE_VALIDATION_QUERY_KEY, phoneNumber, regionCode],
    queryFn: () => validatePhone(phoneNumber, regionCode),
    enabled: !!phoneNumber && !!regionCode,
  });
};
